import type { ApolloCache } from "@apollo/client/cache"

import { TeamFragment, TeamFragmentDoc } from "../graphql/fragment.generated"
import { TeamTypename } from "../types/Team"

export function readTeam(id: string, cache: ApolloCache<object>) {
  const cacheId = cache.identify({ id, __typename: TeamTypename })
  if (!cacheId) return null
  return cache.readFragment<TeamFragment>(
    {
      id: cacheId,
      fragmentName: "Team",
      fragment: TeamFragmentDoc
    },
    true
  )
}
